/**
 * @packageDocumentation
 * @module HackerAPI.User.MailEvent
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import Base from "../../base/base";
/**
 * Data container for mail events with static methods for interfacing with hackerapi
 * @class
 */
var MailEvent = /** @class */ (function (_super) {
    __extends(MailEvent, _super);
    /**
     * Creates an instance of a MailEvent
     * @constructor
     * @param mailEvent
     */
    function MailEvent(payload) {
        var _this = _super.call(this) || this;
        _this.payload = payload;
        return _this;
    }
    /**
     * Fetches all the email events for a user
     * @param auth
     * @param [user] - Defaults to the user whose token was used
     * @param user.id
     * @returns
     */
    MailEvent.fetchAll = function (_a, token) {
        var id = (_a === void 0 ? { id: "me" } : _a).id;
        return HackerAPIFetch({
            path: "/v2/users/" + id + "/mail",
            method: "GET",
            token: token
        }).then(function (data) {
            return data.map(function (datum) { return new MailEvent(datum); });
        });
    };
    return MailEvent;
}(Base));
export default MailEvent;
//# sourceMappingURL=mail-event.js.map